import { useEffect, useState } from "react"
import Button from "./Button"
import { initClarity, getStoredConsent, setClarityConsent, identifyClarityUser } from "../services/clarity"

function CookieConsentBanner({ user }) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    initClarity()

    const decision = getStoredConsent()
    if (decision) {
      setClarityConsent(decision === "granted")
    } else {
      setVisible(true)
    }
  }, [])

  const decide = granted => {
    setClarityConsent(granted)
    if (granted) identifyClarityUser(user)
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 flex flex-col items-center justify-between gap-3 border-t border-gray-200 bg-white p-4 shadow-lg md:flex-row">
      <p className="text-sm text-gray-700">
        We use cookies to understand how you use Encircled and improve your experience. See our
        privacy policy for details.
      </p>
      <div className="flex shrink-0 gap-2">
        <Button variant="gray-ghost" onClick={() => decide(false)}>
          Decline
        </Button>
        <Button variant="default" onClick={() => decide(true)}>
          Accept
        </Button>
      </div>
    </div>
  )
}

export default CookieConsentBanner
